<template>
  <validation-provider :rules="item.rules || null" v-slot="validationContext">
    <b-form-group v-bind="commonFormGroupProps">
      <div class="d-flex align-items-center" style="gap: 10px;">
        <!-- Select Field -->
        <b-form-select
            v-model="selectedValue"
            :options="selectOptions"
            :disabled="isInputMode || item.isDisabled"
            :placeholder="item.selectPlaceholder || 'Select existing option'"
            :style="item.selectStyle || 'width: 200px;'"
            @change="handleSelectChange"
        />
        
        <!-- OR separator -->
        <span class="text-muted">{{ item.separatorText || 'OR' }}</span>
        
        <!-- Input Field -->
        <b-form-input
            v-model="inputValue"
            :disabled="isSelectMode || item.isDisabled"
            :placeholder="item.inputPlaceholder || 'Enter new value'"
            :style="item.inputStyle || 'width: 200px;'"
            @input="handleInputChange"
        />
      </div>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { formMixin } from '@/mixins/formMixin'
import {ValidationProvider} from 'vee-validate'

export default {
  name: 'SelectOrInputForm',
  mixins: [formMixin],
  components: {ValidationProvider},
  props: {
    item: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      selectedValue: null,
      inputValue: '',
      isSelectMode: false,
      isInputMode: false
    }
  },
  computed: {
    commonFormGroupProps () {
      return {
        ...this.getCommonFormGroupProps()
      }
    },
    selectOptions () {
      return this.item.data || []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          // Check if the value matches any select option
          const matchingOption = this.selectOptions.find(option => option.text === newVal)
          if (matchingOption) {
            this.selectedValue = matchingOption.value
            this.isSelectMode = true
            this.isInputMode = false
          } else {
            this.inputValue = newVal
            this.isInputMode = true
            this.isSelectMode = false
          }
        }
      }
    }
  },
  methods: {
    handleSelectChange (value) {
      if (value) {
        this.isSelectMode = true
        this.isInputMode = false
        this.inputValue = ''
        // Find the selected option to get the text value
        const selectedOption = this.selectOptions.find(option => option.value === value)
        const textValue = selectedOption ? selectedOption.text : value
        this.$emit('input', textValue)
        this.$emit('change', { type: 'select', value: textValue })
      } else {
        this.isSelectMode = false
        this.isInputMode = false
        this.$emit('input', null)
      }
    },
    handleInputChange (value) {
      if (value) {
        this.isInputMode = true
        this.isSelectMode = false
        this.selectedValue = null
        this.$emit('input', value)
        this.$emit('change', { type: 'input', value })
      } else {
        this.isInputMode = false
        this.isSelectMode = false
        this.$emit('input', null)
      }
    }
  }
}
</script>

<style scoped>
/* Optional custom styling */
</style> 